export class Intersection {
	observer = null;

	on = false;

	constructor(rootRef, cb) {
		this.rootRef = rootRef;
		this.cb = cb;
	}

	get root() {
		return this.rootRef.current;
	}

	attachNodes() {
		if (!this.observer) return;

		this.root.childNodes.forEach((el) => {
			this.observer.observe(el);
		});
	}

	detachNodes() {
		if (!this.observer) return;

		this.root.childNodes.forEach((el) => {
			this.observer.unobserve(el);
		});
	}

	setOn(state) {
		this.on = state;
	}

	resetObserver() {
		const styles = getComputedStyle(this.root);
		const cardWidth = parseInt(styles.getPropertyValue("--card-width"), 10);

		const blockWidth = parseInt(styles.getPropertyValue("width"), 10);
		const margin = (blockWidth - cardWidth) / 2 - 2;

		this.detachNodes();

		this.observer = new IntersectionObserver(this.cb, {
			root: this.root,
			rootMargin: `0px -${margin}px`,
			threshold: 0.8,
		});

		if (!this.on) return;

		this.attachNodes();
	}
}
